export default function(fit) {

    this._options.fit = fit;

    return this;
};
